import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const sparrowInfraPilotPlugin = createPlugin({
  id: 'sparrow-infra-pilot',
  routes: {
    root: rootRouteRef,
  },
});

export const SparrowInfraPilotPage = sparrowInfraPilotPlugin.provide(
  createRoutableExtension({
    name: 'SparrowInfraPilotPage',
    component: () =>
      import('./components/SipLayout').then(m => m.SipLayout),
    mountPoint: rootRouteRef,
  }),
);
